import { cn } from '../lib/utils';

interface LoadingSkeletonProps {
  rows?: number;
  className?: string;
}

export function LoadingSkeleton({ rows = 3, className }: LoadingSkeletonProps) {
  return (
    <div className={cn('space-y-3', className)}>
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="h-12 animate-pulse rounded-md bg-surface-raised" />
      ))}
    </div>
  );
}
